<script>
    import { fly } from 'svelte/transition'

    export let delay = 1
    export let random = 0
    if (random > 0) {
        delay = Math.ceil(Math.random() * random)
    }
</script>

{#if delay > 0}
    <div in:fly|global={{ y: -50, duration: 150, delay: delay + 300 }} out:fly|global={{ y: 50, duration: 150 }}>
        <slot />
    </div>
{:else}
    <slot />
{/if}

<style>
    div {
        overflow: hidden;
        max-height: 100%;
    }
</style>
